module.exports = __webpack_public_path__ + "static/media/IMG_0773.6488db8d.jpg";